import { render, staticRenderFns } from "./MultiplePersonSelect.vue?vue&type=template&id=b0ce0e0a&scoped=true"
import script from "./MultiplePersonSelect.vue?vue&type=script&lang=js"
export * from "./MultiplePersonSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ce0e0a",
  null
  
)

export default component.exports